import { shippingLabelTemplateSchema } from "@redotech/redo-fulfillment-operations-common/shipping-label/shipping-label-template-definition";

export const updateShippingLabelTemplate = {
  name: "updateShippingLabelTemplate" as const,
  input: shippingLabelTemplateSchema,
  output: shippingLabelTemplateSchema,
};
